/* FerriFirenze site interests. With the visitor's consent, an anonymous id and a few events (pieces and collections viewed, saved pieces, searches, Concierge clicks)
   go to the private-area app (never to the ERP). When the visitor writes to the Concierge the message carries a short visitor code, so the team sees the history on the client card. */
(function () {
  var C = window.FF_TRACK; if (!C || !C.url) return;
  var KEY = 'ffv', Q = [], timer = null;
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function vid() {
    var v = lsGet(KEY);
    if (!v || !/^[a-z0-9]{24}$/.test(v)) {
      var a = new Uint8Array(24), s = 'abcdefghijklmnopqrstuvwxyz0123456789'; (window.crypto || window.msCrypto).getRandomValues(a);
      v = ''; for (var i = 0; i < 24; i++) v += s[a[i] % 36]; lsSet(KEY, v);
    }
    return v;
  }
  var allowed = false;
  function flush() {
    timer = null; if (!allowed || !Q.length) return;
    var body = JSON.stringify({ v: vid(), country: C.country, lang: C.lang, events: Q.splice(0, 20) });
    try { if (!(navigator.sendBeacon && navigator.sendBeacon(C.url, new Blob([body], { type: 'text/plain' })))) fetch(C.url, { method: 'POST', body: body, mode: 'cors', keepalive: true, headers: { 'content-type': 'text/plain' } }); } catch (e) {}
    if (Q.length) flush();
  }
  function ev(t, o) { o = o || {}; Q.push({ t: t, code: o.code || null, col: o.col ? String(o.col).slice(0, 40) : null, q: o.q ? String(o.q).slice(0, 80) : null, page: location.pathname.slice(0, 200), ts: Date.now(), title: o.title ? String(o.title).slice(0, 140) : null, img: o.img ? String(o.img).slice(0, 400) : null, url: o.url ? String(o.url).slice(0, 300) : null }); if (!timer) timer = setTimeout(flush, 1500); }
  function start() {
    allowed = true;
    var p = document.querySelector('[data-product]'), pub = null;
    if (p && p.dataset.code) {
      var mt = function (n) { var m = document.querySelector('meta[property="' + n + '"]'); return m ? m.content : ''; };
      var h1 = p.querySelector('h1'), im = p.querySelector('figure.ph img') || p.querySelector('img');
      var img = (im && (im.currentSrc || im.src)) || mt('og:image');
      var pub = { code: p.dataset.code, col: p.dataset.col,
        title: ((h1 && h1.textContent) || mt('og:title') || '').trim().slice(0, 140),
        img: /^https:\/\//.test(img) ? img.split('?')[0] + '?width=800' : '',
        url: location.origin + location.pathname };
      ev('view_piece', pub);
    }
    if (C.tpl === 'collection' && C.col) ev('view_collection', { col: C.col });
    if (C.tpl === 'search' && C.q) ev('search', { q: C.q });
    var sv = document.getElementById('saveBtn');
    if (sv && p) sv.addEventListener('click', function () { setTimeout(function () { var saved = /saved/i.test(sv.textContent) || sv.textContent === (window.FF && FF.t && FF.t.savedP); ev(saved ? 'save_piece' : 'unsave_piece', pub || { code: p.dataset.code, col: p.dataset.col }); }, 0); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
      var h = a.getAttribute('href') || '';
      if (h.indexOf('wa.me/') > -1) {
        var code = (h.match(/WEB-[A-Z]+-(FF[0-9A-Z]+)-/) || [])[1] || (p && p.dataset.code) || null;
        ev('concierge_click', { code: code }); flush();
        if (!/-V[a-z0-9]{10}/.test(h)) a.setAttribute('href', h.replace(/(Ref\.(%20|\+|\s)WEB-[A-Za-z0-9-]+)/, '$1-V' + vid().slice(0, 10)));
      } else if (C.private && h.indexOf(C.private) === 0) {
        ev('open_private'); flush();
        var u = new URL(h); u.searchParams.set('v', vid()); a.setAttribute('href', u.toString());
      }
    }, true);
    addEventListener('pagehide', flush);
  }
  /* consent: Shopify's Customer Privacy API decides where a banner is required (EU, UK); elsewhere analytics is allowed by default */
  function banner(cp) {
    if (lsGet('ffc')) return;
    var b = document.createElement('div'); b.className = 'ffc'; b.setAttribute('role', 'dialog'); b.setAttribute('aria-label', C.t.title);
    b.innerHTML = '<p></p><div><button type="button" class="no"></button><button type="button" class="ok"></button></div>';
    b.querySelector('p').textContent = C.t.text; b.querySelector('.ok').textContent = C.t.ok; b.querySelector('.no').textContent = C.t.no;
    function set(yes) { lsSet('ffc', yes ? '1' : '0'); b.remove(); try { cp.setTrackingConsent({ analytics: yes, preferences: yes, marketing: false }, function () {}); } catch (e) {} if (yes) start(); }
    b.querySelector('.ok').onclick = function () { set(true); }; b.querySelector('.no').onclick = function () { set(false); };
    document.body.appendChild(b);
  }
  function decide() {
    var cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp) { if (lsGet('ffc') === '1') start(); return; }
    if (lsGet('ffc') === '0') return;
    if (cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()) { start(); return; }
    if (lsGet('ffc') === '1') { start(); return; }
    if (!cp.shouldShowBanner || cp.shouldShowBanner()) banner(cp);
  }
  /* g5p footer "Cookies Settings": reopen this choice at any time */
  window.ffCookieChoice = function () { var o = document.querySelector('.ffc'); if (o) o.remove(); try { localStorage.removeItem('ffc'); } catch (e) {} banner((window.Shopify && Shopify.customerPrivacy) || {}); };
  if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { decide(); });
  else decide();
})();
